<template>
  <div>
    <v-icon @click="abrirDialog" :size="15" class="cursor-pointer">mdi-pencil</v-icon>

    <SysDialogFullscreen v-model="dialog_ativo">
      <template #titulo>
        <v-btn icon dark @click="fecharDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <div class="ml-5">
          <p class="ma-0">Similares</p>
          <p class="ma-0 mt-n3 text-uppercase font-12">
            {{ produto.id_produto }} - {{ produto.descricao_produto }}
          </p>
        </div>

        <div class="h-full py-1">
          <v-divider vertical dark class="mx-5" />
        </div>

        <ConverterEmbalagem dark />
      </template>

      <v-card class="mx-2 mt-2">
        <div class="text-gray-900 px-3 pt-2 pb-2 d-flex align-center">
          <v-icon>mdi-format-list-bulleted</v-icon>
          <span class="font-20 font-weight-medium ml-1">Lista de similares</span>

          <v-spacer />

          <NovoSimilar
            :detalhesProduto="{ ...produto, idproduto: produto.id_produto }"
            :disabled="!habilitar_edicao_parametros"
            @atualizar-similares="buscarListaDeSimilares();$emit('update:similar', $event)"
          />
        </div>

        <v-data-table
          :headers="cabecalhos"
          :items="similares"
          :search="pesquisa"
          fixed-header
          :items-per-page="-1"
          item-key="item_key"
          height="calc(100vh - 210px)"
          class="table-full-screen ml-2 mr-1"
        >
          <template #item.agregar_estoque="{item}">
            {{ item.agregar_estoque === 'S' ? 'SIM' : 'NÃO' }}
          </template>

          <template #item.fator_conversao="{item}">
            {{ Helpers.formatarValor(converteEmbalagemValor(item.fator_conversao)) }}
          </template>

          <template #item.consumo_medio_mensal="{item}">
            {{ Helpers.formatarValor(converteEmbalagemValor(item.consumo_medio_mensal)) }}
          </template>

          <template #item.estoque="{item}">
            {{ Helpers.formatarValor(converteEmbalagemValor(item.estoque)) }}
          </template>

          <template #item.compra_transito="{item}">
            {{ Helpers.formatarValor(converteEmbalagemValor(item.compra_transito)) }}
          </template>

          <template #item.nivel_estoque="{item}">
            <div class="py-1 text-center cursor-help" :title="item.status_produto">
              <NivelEstoqueProgressCircular
                :valor="item.nivel_estoque"
                :status-produto="item.status_produto"
                :tamanho="45"
                :largura="4"
              />
            </div>
          </template>

          <template #item.acoes="{item}">
            <div class="d-flex align-center">
              <EditarSimilar
                :produto="produto"
                :similar_edicao="{id_produto: item.idproduto, idunidade_medida: item.unidade_venda, agredar_estoque: item.agregar_estoque === 'S'}"
                @update:novo-similar="buscarListaDeSimilares"
              >
                <template #bota-ativador="{callbackAbrirDialog}">
                  <v-btn :disabled="!habilitar_edicao_parametros" icon @click="callbackAbrirDialog()">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
              </EditarSimilar>

              <v-btn
                class="ml-n2" icon
                :disabled="!habilitar_edicao_parametros"
                @click="apagarProdutoSimilar(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </SysDialogFullscreen>
  </div>
</template>

<script>
import {logout} from "@/helpers";
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen";
import ConverterEmbalagem from "@/components/compra/Embalagem/ConverterEmbalagem";
import CompraAPI from "@/api/compra";
import NovoSimilar from '@/components/compra/detalhesProduto/Similares/DialogCadastro.vue';
import EditarSimilar from './NovoSimilar.vue';
import NivelEstoqueProgressCircular from "@/components/produto/detalhes/NivelEstoqueProgressCircular";

export default {
  name: "Similar",
  components: {NivelEstoqueProgressCircular, NovoSimilar, EditarSimilar, ConverterEmbalagem, SysDialogFullscreen},
  props: {
    produto: Object,
    habilitar_edicao_parametros: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog_ativo: false,
    cabecalhos: [
      { text: "Cód. Interrno", value: "idproduto" },
      { text: "Cód. Fornecedor", value: "idfornecedor" },
      { text: "Marca", value: "marca" },
      { text: "Descrição", value: "descricao_produto" },
      { text: "Filial", value: "filial" },
      { text: "Agregar Estoque", value: "agregar_estoque" },
      { text: "UN. Compra", value: "unidade_compra" },
      { text: "Fator de Conversão", value: "fator_conversao" },
      { text: "Projeção de vendas", value: "consumo_medio_mensal" },
      { text: "Estoque", value: "estoque" },
      { text: "Compra em trânsito", value: "compra_transito" },
      { text: "Nível estoque", value: "nivel_estoque" },
      {text: "Ações", value: "acoes", sortable: false},
    ],
    similares: [],
    pesquisa: ''
  }),
  computed: {
    embalagemMasterAtivada() {
      return this.$store.getters["EmbalagemTelaDeCompras/getEmbalagemMaster"];
    }
  },
  methods: {
    abrirDialog() {
      this.dialog_ativo = ! this.dialog_ativo;
      this.buscarListaDeSimilares();
    },
    fecharDialog() {
      this.dialog_ativo = false;
      this.$emit("update:similar");
    },
    buscarListaDeSimilares() {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        grupo: this.produto.id_grupo,
        pai: this.produto.id_produto,
        filial: (this.produto.id_filial === 9999) ? 0 : this.produto.id_filial,
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.getSimilares(headers, params)
          .then((response) => {
            const { token, similares } = response.data
            localStorage.token = token;
            this.similares = similares;
          })
          .catch(logout)
      )
    },
    apagarProdutoSimilar(similar) {
      const headers = this.Helpers.iniciarRequisicao()

      const params = {
        grupo: this.produto.id_grupo,
        pai: this.produto.id_produto,
        filho: similar.idproduto
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CompraAPI.deleteSimilares(headers, params)
          .then((response) => {
            localStorage.token = response.data.token;
            this.buscarListaDeSimilares();
            this.$emit('update:similar', {});
          })
          .catch(logout)
      )
    },
    converteEmbalagemValor(valor) {
      const multiploCompra = this.produto.multiplo_compra || 1;

      if (this.produto.tipo_fator_conversao === 'D') {
        return this.embalagemMasterAtivada ? (valor / multiploCompra) : valor;
      }

      return this.embalagemMasterAtivada ? (valor * multiploCompra) : valor;
    },
  }
}
</script>

<style scoped>

</style>
